// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    plantSelection: state.greif.pages.contactUs.plantFieldValues,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

interface ContactUsCSRInfosStyles {
    wrapper?: InjectableCss;
    headerText?: TypographyProps;
    nameText?: TypographyProps;
    infoText?: TypographyProps;
}

const contactUsCSRInfosStyles: ContactUsCSRInfosStyles = {
    wrapper: {
        css: css`
            ${spacingStyles(pxToRem(48), pxToRem(32))}
        `,
    },
    headerText: {
        as: "p",
        forwardAs: "h2",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            line-height: ${x => x.theme.design.typography.lineHeight.smaller};
            margin-bottom: ${pxToRem(16)};
        `,
    },
    nameText: {
        as: "p",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
            line-height: ${x => x.theme.design.typography.lineHeight.smaller};
            margin-bottom: ${pxToRem(16)};
        `,
    },
    infoText: {
        as: "p",
        css: css`
            line-height: ${x => x.theme.design.typography.lineHeight.smaller};
            margin-bottom: ${pxToRem(16)};
        `,
    },
};

const styles = contactUsCSRInfosStyles;

const ContactUsCSRInfos: FC<Props> = ({ plantSelection }) => {
    if (!plantSelection || !plantSelection.firstName) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.headerText}>{translate("Customer Service")}</Typography>
            {plantSelection?.firstName && (
                <Typography {...styles.nameText}>
                    <Typography>{`${plantSelection.firstName} ${plantSelection.lastName} | ${plantSelection.role}`}</Typography>
                </Typography>
            )}
            {plantSelection?.email && (
                <Typography {...styles.infoText}>
                    <Typography>{`${translate("Email")}${translate(":")} `}</Typography>
                    <Link href={`mailto:${plantSelection.email}`}>{plantSelection.email}</Link>
                </Typography>
            )}
            {plantSelection?.officePhone && (
                <Typography {...styles.infoText}>
                    <Typography>{`${translate("Office")}${translate(":")} ${plantSelection?.officePhone}`}</Typography>
                </Typography>
            )}
            {plantSelection?.cellPhone && (
                <Typography {...styles.infoText}>
                    <Typography>{`${translate("Cell")}${translate(":")} ${plantSelection.cellPhone}`}</Typography>
                </Typography>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, null)(ContactUsCSRInfos),
    definition: {
        displayName: "Customer service Rep Infos",
        group: "Contact Us",
    },
};

export default widgetModule;
